/**
 * Monitoring Types
 * Defines types for monitoring and telemetry services
 */

export type Span = {
  traceId: string;
  spanId: string;
  parentSpanId?: string;
  name: string;
  kind: SpanKind;
  startTimeUnixNano: number;
  endTimeUnixNano: number;
  attributes: Record<string, string | number | boolean>;
  events?: SpanEvent[];
  status: SpanStatus;
};

export type SpanEvent = {
  name: string;
  timeUnixNano: number;
  attributes?: Record<string, string | number | boolean>;
};

export enum SpanKind {
  INTERNAL = 1,
  SERVER = 2,
  CLIENT = 3,
  PRODUCER = 4,
  CONSUMER = 5,
}

export enum SpanStatus {
  UNSET = 0,
  OK = 1,
  ERROR = 2,
}

export type TraceExporterOptions = {
  endpoint: string;
  organizationHeader: string;
  organizationId: string;
  serviceName: string;
  batchSize?: number;
  flushIntervalMs?: number;
};

/**
 * Monitoring Configuration
 * Defines the configuration options for the monitoring service
 */
export type MonitoringConfig = {
  enabled: boolean;
  sendToTempo?: boolean;
  tempoEndpoint?: string;
  tempoTenantHeader?: string;
  tempoTenantId?: string;
  serviceName?: string;
};

// Token for the monitoring service
export const MONITORING_SERVICE = 'MONITORING_SERVICE';
